import { useUserLocale } from '../../../state/locale/hooks/useUserLocale'

export const GlobalHooks = () => {
  useUserLocale()

  return null
}
